import { useEffect, useRef, useState } from 'react';
import { Bell, Search, ShoppingCart, ChevronDown, LogOut, CircleUserRound, Phone, ChevronUp,
         CreditCard, Headphones, Package, RefreshCw, ChevronRight ,Settings, HelpCircle, Menu,
         Sun, Moon
 } from 'lucide-react';
import { FaTelegramPlane, FaInstagram, FaWhatsapp  } from "react-icons/fa";
import { LiaFacebook } from "react-icons/lia";
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { BASE_URL, appConfig } from '../apiConfig';
import Cookies from 'js-cookie';
import { useAuth } from '../context/AuthProvider';
import { useLanguage } from '../context/LanguageProvider';
import { useTheme } from '../context/ThemeProvider';

export default function Header({ open, setOpen }) {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [ModalPhones, setModalPhones] = useState(false);
  const dropdownRef = useRef(null);
  const { user, token, logout } = useAuth();
  const { t, locale, changeLanguage, supportedLocales } = useLanguage();
  const { isDark, toggleTheme } = useTheme();
  const [config, setConfig] = useState(() => {
    const configCookie = Cookies.get('config');
    try {
      return configCookie ? JSON.parse(configCookie) : [];
    } catch (error) {
      return [];
    }
  });
  const [CountCart, setCountCart] = useState(0);

  useEffect(() => {
    const configCookie = Cookies.get('config');
    if (configCookie) {
      try {
        setConfig(JSON.parse(configCookie));
      } catch (error) {
        console.error('Error parsing config cookie:', error);
      }
    }
  }, []);

  useEffect(() => {
    const updateCartCount = () => {
      try {
        const cart = JSON.parse(Cookies.get('cart') || '[]');
        setCountCart(cart.length);
      } catch (error) {
        console.error('Error parsing cart cookie:', error);
        setCountCart(0);
      }
    };

    updateCartCount();
    
    const cartInterval = setInterval(updateCartCount, 2000);
    return () => clearInterval(cartInterval);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      // Best to try server logout, but always clear local state
      if (token) {
        await axios.post(
          BASE_URL + '/api/logout',
          { token },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        ).catch(err => console.error("Server logout error:", err));
      }
    } finally {
      logout();
      setDropdownOpen(false);
      navigate('/login');
    }
  };

  const getUserInfo = () => {
    if (!user) return null;
    
    if (user.role === 1 || user.role === 2) {
      return user.admin_info || null;
    } else if (user.role === 3) {
      return user.confirmator || null;
    } else if (user.role === 4) {
      return user.livreur_info || null;
    } else if (user.role === 0) {
      return user.saller_info_active || null;
    }
    
    return null;
  };

  const getUserInitial = () => {
    const userInfo = getUserInfo();
    if (!userInfo || !userInfo.name) return '';
    return userInfo.name.charAt(0).toUpperCase();
  };

  const getUserName = () => {
    const userInfo = getUserInfo();
    if (!userInfo || !userInfo.name) return '';
    return userInfo.name;
  };

  const getUserRole = () => {
    if (!user) return '';
    if (user.role === 1) return t('header.role_admin');
    if (user.role === 2) return t('header.role_assistant');
    if (user.role === 3) return t('header.role_confirmator');
    if (user.role === 4) return t('header.role_livreur');
    if (user.role === 0) return t('header.role_seller');
    return '';
  };

  const userInfo = getUserInfo();

  return (
    // <header className="bg-white border-b h-[9vh] border-gray-200 sticky top-0 z-[99]">
     <header className="bg-white h-[9vh] border-gray-200 sticky top-0 z-[99]">
      <div className="px-4 sm:px-6 lg:px-6">
        <div className="flex h-[9vh] items-center justify-between">
          <div className="flex items-center gap-2">
            <button
              className="max-lg:hidden p-2 rounded-md hover:bg-gray-100 cursor-pointer transition-colors"
              onClick={() => setOpen(!open)}
              title={open ? 'Fermer le menu' : 'Ouvrir le menu'}
            >
              <Menu className="h-5 w-5 text-gray-600 dark:text-white" />
            </button>
            <Link to="/dashboard" className="flex items-center max-xs:w-[25%] cursor-pointer lg:hidden">
              <img
                src={!isDark ? `/images/${appConfig.slug}-logo.png` : `/images/${appConfig.slug}-logo-whitee.png`}
                alt={appConfig.name}
                width={150}
                height={100}
              />
            </Link>
            <div className="hidden lg:flex items-center gap-2 flex-1 max-w-lg mx-2 min-w-[400px]">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-white h-4 w-4" />
                <input
                  type="text"
                  placeholder={t('header.search_placeholder')}
                  className="w-full text-xs dark:text-white pl-10 pr-4 py-2 border border-gray-200 rounded-lg bg-gray-50 focus:bg-white focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                />
              </div>
              <button className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 flex items-center space-x-2 dark:bg-stone-900 dark:text-white">
                <span className="text-xs">{t('header.filter')}</span>
              </button>
            </div>
          </div>


          <div className="flex items-center space-x-3 relative ">
            {
              user.role !== 4 ? (
                <div className='flex items-center gap-3'> 
                  <div className="flex items-center gap-3 ">
                    {config?.telegram && (
                      <Link className="cursor-pointer" target="_blank" to={config.telegram}>
                        <FaTelegramPlane className="text-[#3390ec] w-4.5 h-4.5 dark:text-white" />
                      </Link>
                    )}
                    {config?.instagram && (
                      <Link className="cursor-pointer" target="_blank" to={config.instagram}>
                        <FaInstagram className="text-[#de317f] w-4.5 h-4.5 dark:text-white" />
                      </Link>
                    )}
                    {config?.facebook && (
                      <Link className="cursor-pointer" target="_blank" to={config.facebook}>
                        <LiaFacebook className="text-[#0866ff] w-5 h-5 dark:text-white" />
                      </Link>
                    )}

                    <div className="relative inline-block text-left max-xl:hidden">
                        {/* Dropdown button */}
                        <div onClick={() => setModalPhones(prev => !prev)} className="flex items-center cursor-pointer bg-gray-50 rounded-md gap-2 py-2 px-3 hover:bg-gray-100 transition">
                          <Phone className="w-3.5 h-3.5 text-gray-700" />
                          {
                            ModalPhones ?
                              <ChevronUp className="w-3 h-3 text-gray-700" />
                              :
                              <ChevronDown className="w-3 h-3 text-gray-700" />
                          }
                        </div>

                        {/* Dropdown menu */}
                        <div
                            className={`absolute ${ModalPhones ? 'block' : 'hidden'} ${locale === "ar" ? 'left-0' : ''} mt-1 w-52 bg-white border border-gray-200 rounded-md shadow-lg z-10`}
                          >
                            <ul className="py-2">
                              {config?.phone_support && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <Headphones className="w-4 h-4" />
                                  <a href={`tel:${config.phone_support}`} className="block">
                                    {t('header.support')}: {config.phone_support}
                                  </a>
                                </li>
                              )}
                              {config?.phone_stock && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <Package className="w-4 h-4" />
                                  <a href={`tel:${config.phone_stock}`} className="block">
                                    {t('header.stock')}: {config.phone_stock}
                                  </a>
                                </li>
                              )}
                              {config?.phone_payment && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <CreditCard className="w-4 h-4" />
                                  <a href={`tel:${config.phone_payment}`} className="block">
                                    {t('header.payment')}: {config.phone_payment}
                                  </a>
                                </li>
                              )}
                              {config?.phone_change && (
                                <li className="flex items-center gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <RefreshCw className="w-4 h-4" />
                                  <a href={`tel:${config.phone_change}`} className="block">
                                    {t('header.exchange')}: {config.phone_change}
                                  </a>
                                </li>
                              )}
                            </ul>
                          </div>

                      </div>

                  </div>
                  
                  <div className='w-1 h-8 border-l border-gray-200'></div>

                  <button
                    onClick={toggleTheme}
                    className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700 cursor-pointer"
                    title={isDark ? 'Light mode' : 'Dark mode'}
                  >
                    {isDark ? <Sun className="w-4 h-4 dark:text-white" /> : <Moon className="w-4 h-4" />}
                  </button>

                  <div className="inline-flex max-xl:ml-2 items-center h-7 p-[2px] gap-0.5 rounded-lg border border-gray-200 bg-gray-100">
                    {supportedLocales.map(({ code }) => (
                      <button
                        key={code}
                        onClick={() => changeLanguage(code)}
                        className={`
                          flex items-center gap-0.5 h-full px-2.5 rounded-md text-[12px] font-medium
                          tracking-wide transition-colors cursor-pointer
                          ${locale === code
                            ? 'bg-white text-gray-900 border border-gray-200 dark:bg-stone-900'
                            : 'text-gray-400 hover:text-gray-700'}
                        `}
                        title="Changer la langue"
                      >
                        <span className="uppercase text-[11px] leading-none">{code}</span>
                      </button>
                    ))}
                  </div>

                  <Link to="/cart" className="relative max-xl:hidden">
                    <ShoppingCart className="h-4 w-4 dark:text-white" />
                    {CountCart > 0 && (
                      <span className="absolute bg-[var(--color-primary-500)] text-xs w-4 h-4 pt-0.1 top-[-12px] right-[-10px] text-center text-white rounded-full dark:text-white">
                        {CountCart}
                      </span>
                    )}
                  </Link>
                  <button className="relative max-xl:hidden p-2 rounded-lg hover:bg-gray-100">
                    <Bell className="h-4 w-4 dark:text-white" />
                    <span className="absolute -top-1 -right-1 h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center animate-pulse dark:text-white">
                      3
                    </span>
                  </button>
                </div>
              ) : 
              (
                <div className='flex items-center gap-2'>
                  <div className="inline-flex max-xl:ml-2 items-center h-7 p-[2px] gap-0.5 rounded-lg border border-gray-200 bg-gray-100">
                    {supportedLocales.map(({ code }) => (
                      <button
                        key={code}
                        onClick={() => changeLanguage(code)}
                        className={`
                          flex items-center gap-0.5 h-full px-2.5 rounded-md text-[12px] font-medium
                          tracking-wide transition-colors cursor-pointer
                          ${locale === code
                            ? 'bg-white text-gray-900 border border-gray-200 dark:bg-stone-900'
                            : 'text-gray-400 hover:text-gray-700'}
                        `}
                        title="Changer la langue"
                      >
                        <span className="uppercase text-[11px] leading-none">{code}</span>
                      </button>
                    ))}
                  </div>
                  <div className='w-1 h-8 border-l border-gray-200'></div>
                  <button
                      onClick={toggleTheme}
                      className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700 cursor-pointer"
                      title={isDark ? 'Light mode' : 'Dark mode'}
                      >
                      {isDark ? <Sun className="w-4 h-4 dark:text-white" /> : <Moon className="w-4 h-4" />}
                  </button>
                </div>
              )
            }

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`${locale === "ar" ? 'pr-3 border-r' : 'pl-3 border-l'} flex items-center gap-2 border-gray-200 cursor-pointer`}
              >
                {userInfo?.logo ? (
                    <img src={`${BASE_URL}/storage/${userInfo.logo}`} className="h-8 w-8 rounded-full object-cover" />
                  ) : (
                    <div className="h-8 w-8 bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-300)] rounded-full flex items-center justify-center text-white font-semibold">
                      {getUserInitial()}
                    </div>
                  )}
                <div className="hidden lg:block text-left space-y-[-2px]">
                  <p className="text-[11px] font-semibold text-gray-900">{getUserName()}</p>
                  <p className="text-[11px] text-gray-500">{getUserRole()}</p>
                </div>
                <ChevronDown className="h-4 w-4 text-gray-400 hidden lg:block" />
              </button>

              {dropdownOpen && (
                <div
                  className={`absolute ${locale === "ar" ? "left-0" : "right-0"} top-full mt-2 w-64 z-50
                              bg-white border border-gray-100 shadow-xl rounded-2xl overflow-hidden
                              animate-[dropdownIn_0.15s_ease-out]`}
                >
                  <style>{`
                    @keyframes dropdownIn {
                      from { opacity: 0; transform: translateY(-6px) scale(0.97); }
                      to   { opacity: 1; transform: translateY(0) scale(1); }
                    }
                  `}</style>

                  {/* User info header */}
                  <div className="flex items-center gap-3 px-4 py-3.5 bg-gray-50/70 dark:bg-stone-900">
                    <div className="relative shrink-0">
                      {userInfo?.logo ? (
                        <img
                          src={`${BASE_URL}/storage/${userInfo.logo}`}
                          className="h-10 w-10 rounded-full object-cover"
                        />
                      ) : (
                        <div className="h-10 w-10 bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-300)] rounded-full flex items-center justify-center text-white text-sm font-semibold">
                          {getUserInitial()}
                        </div>
                      )}
                      <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full bg-emerald-500 border-2 border-white" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-gray-800">{getUserName()}</p>
                      <p className="truncate text-xs text-gray-400">{getUserRole()}</p>
                    </div>
                  </div>

                  {/* Primary actions */}
                  <div className="p-1.5">
                    <Link to="/profile" onClick={() => setDropdownOpen(false)}>
                      <button className="group flex w-full items-center justify-between rounded-lg px-3 py-2 text-xs font-medium text-gray-700 transition-colors hover:bg-[var(--color-primary-50)] hover:text-[var(--color-primary-700)]">
                        <span className="flex items-center gap-2.5">
                          <CircleUserRound size={17} strokeWidth={1.75} />
                          {t('header.profile')}
                        </span>
                        <ChevronRight
                          size={14}
                          className={`text-gray-300 opacity-0 transition-opacity group-hover:opacity-100 ${locale === "ar" ? "rotate-180" : ""}`}
                        />
                      </button>
                    </Link>

                    <Link to="/configs" onClick={() => setDropdownOpen(false)}>
                      <button className="group flex w-full items-center justify-between rounded-lg px-3 py-2 text-xs font-medium text-gray-700 transition-colors hover:bg-[var(--color-primary-50)] hover:text-[var(--color-primary-700)]">
                        <span className="flex items-center gap-2.5">
                          <Settings size={17} strokeWidth={1.75} />
                          {t('header.settings')}
                        </span>
                        <ChevronRight
                          size={14}
                          className={`text-gray-300 opacity-0 transition-opacity group-hover:opacity-100 ${locale === "ar" ? "rotate-180" : ""}`}
                        />
                      </button>
                    </Link>

                    <Link to="/help" onClick={() => setDropdownOpen(false)}>
                      <button className="group flex w-full items-center justify-between rounded-lg px-3 py-2 text-xs font-medium text-gray-700 transition-colors hover:bg-[var(--color-primary-50)] hover:text-[var(--color-primary-700)]">
                        <span className="flex items-center gap-2.5">
                          <HelpCircle size={17} strokeWidth={1.75} />
                          {t('header.help')}
                        </span>
                        <ChevronRight
                          size={14}
                          className={`text-gray-300 opacity-0 transition-opacity group-hover:opacity-100 ${locale === "ar" ? "rotate-180" : ""}`}
                        />
                      </button>
                    </Link>
                  </div>

                  <div className="h-px bg-gray-100 mx-3" />

                  {/* Logout */}
                  <div className="p-1.5">
                    <button
                      onClick={handleLogout}
                      className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-xs font-medium text-red-500 transition-colors hover:bg-red-50"
                    >
                      <LogOut size={17} strokeWidth={1.75} />
                      {t('header.logout')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}